import _toConsumableArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import React__default from 'react';
import { L as Label, a as LabelTypography, b as LabelColors } from '../index-6420013c.js';
import 'prop-types';
import '../stringSet-b60e9529.js';
var ButtonTypes$1 = /*#__PURE__*/function (ButtonTypes) {
  ButtonTypes["PRIMARY"] = "PRIMARY";
  ButtonTypes["SECONDARY"] = "SECONDARY";
  ButtonTypes["DANGER"] = "DANGER";
  ButtonTypes["DISABLED"] = "DISABLED";
  return ButtonTypes;
}({});
var ButtonSizes$1 = /*#__PURE__*/function (ButtonSizes) {
  ButtonSizes["BIG"] = "BIG";
  ButtonSizes["SMALL"] = "SMALL";
  return ButtonSizes;
}({});
function changeTypeToClassName(type) {
  switch (type) {
    case ButtonTypes$1.PRIMARY:
      return 'sendbird-button--primary';
    case ButtonTypes$1.SECONDARY:
      return 'sendbird-button--secondary';
    case ButtonTypes$1.DANGER:
      return 'sendbird-button--danger';
    case ButtonTypes$1.DISABLED:
      return 'sendbird-button--disabled';
    default:
      return null;
  }
}
function changeSizeToClassName(size) {
  switch (size) {
    case ButtonSizes$1.BIG:
      return 'sendbird-button--big';
    case ButtonSizes$1.SMALL:
      return 'sendbird-button--small';
    default:
      return null;
  }
}
var ButtonTypes = ButtonTypes$1;
var ButtonSizes = ButtonSizes$1;
function Button(_ref) {
  var className = _ref.className,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? ButtonTypes.PRIMARY : _ref$type,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? ButtonSizes.BIG : _ref$size,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? 'Button' : _ref$children,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {/* noop */} : _ref$onClick;
  var injectingClassNames = [].concat(_toConsumableArray(Array.isArray(className) ? className : [className]), ['sendbird-button', disabled ? 'sendbird-button__disabled' : '', changeTypeToClassName(type), changeSizeToClassName(size)]).join(' ');
  return /*#__PURE__*/React__default.createElement("button", {
    className: injectingClassNames,
    type: "button",
    onClick: onClick,
    disabled: disabled
  }, /*#__PURE__*/React__default.createElement(Label, {
    className: "sendbird-button__text",
    type: LabelTypography.BUTTON_1,
    color: LabelColors.ONCONTENT_1
  }, children));
}
export { ButtonSizes, ButtonTypes, Button as default };